import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import Tab1 from './Tab1';
import { UserOutlined } from '@ant-design/icons';
import RELATION from '../../../Models/Relation';
import axios from 'axios';
import SweetAlert from "sweetalert2";
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../Models/Utilisateur';
import { Crypter } from '../../../Functions/Security/Crypter';
import DataRelationClient from '../../../Types/DataRelationClient';
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import theme from 'antd';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "../../../Styles/StyleHome.css";
import { useNavigate } from 'react-router-dom';
import VerifDay from '../../../Functions/Traitement/VerifDay';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;

//CreateNewCLIENT
let Data = require('../../../Data/Data.json');
let Link = require('../../../Data/Data.json');

const Relation = () => {

  const [dataRCL, SetData] = useState<DataRelationClient[]>([]);
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("");
  const [Load, SetLoad] = useState(false);
  const Navigate=useNavigate();

  useEffect(() => {
    forceUpdate({});
    if(Load===false)
    {
      VerifDay(user.coduti,user.codage,authHeader,Navigate);
      SetLoad(true);
     }
  }, []);

  function initialiazeButton()
   {
    SeStartSearchG(false)
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    let data = form.getFieldValue("idClient")?form.getFieldValue("idClient"):'';
    if(data.length>0){
    let  NUMCLI=form.getFieldValue("idClient");
    let Lib_NUMCLI=form.getFieldValue("lib_idClient");
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    form.resetFields()
    form.setFieldValue("idClient", NUMCLI)
    form.setFieldValue("lib_idClient", Lib_NUMCLI)
    form.setFieldValue("niveau", 900)
  }
   else  SweetAlert.fire({ title: "Veuillez Saisir l'identifiant du client", text: "", icon: 'info', confirmButtonText: 'OK' })
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    SetData([]);
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    window.location.reload()
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Relation
        </span>
      ),
      children: <Tab1 etatG={StartSearchG} form={form} data={dataRCL}  />,
    }
  ];


  const onFinish = (values: any) => {
    var relation: RELATION = values

    relation.agccpt=user.codage;
    relation.Utilis = user.coduti;
    

    if (sbmit == "add") {
      relation.DatCre=(new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/",'-');
      SweetAlert.fire({
        title: "Enregistrement de la relation",
        text: "Voulez-vous enregistrer  " + relation.NomRel + " " + relation.Prenom + " " + "comme relation " + " " + relation.lib_filiation + " " + "de" + " " + relation.lib_idClient + "?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)
          //let group = profilsDistant.find(()=>)

          relation.DatCre = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
          console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(relation)));

          let data = Crypter.encrypt(JSON.stringify(relation));
          //console.log(data);
          let config = {
            method: 'post',
            maxContentLength: 52428890,
            maxBodyLength: Infinity,
            url: Link.ApiUrl.CreateNewRELATION,
            headers: {
              'Accept': '*/*',
              // 'CypherRelation': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                  //form.setFieldsValue({'idClient':'','lib_idClient':'','CODREL':'','lib_CODREL':'','filiation':'','TitRel':'','lib_TitRel':'','filiation':'','Prenom':'','adresRel':'','dateNais':'','cni':'','DatExpirCni':'','TelRel':'','Signataire':'N','check':true,'Photo':'','Signature':'','ayantd':'N'})
                  localStorage.clear()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Message, text: res.Result,     confirmButtonText: "Yes",
                  confirmButtonColor: "green", icon: "success" }).then((result)=>{
                    if (result.isConfirmed || result.isDenied) {
                      window.location.reload();
                      localStorage.clear()
                      initialiazeButton()
            
                      setSbmit("")
                    }

                  })
                }
                else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
            });

        }
      })
    }
    if (sbmit == "update") {
      //console.log(values)
      SweetAlert.fire({
        title: "Modification du Client",
        text: "Voulez-vous modifier la relation " + relation.CODREL + " ?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)

          console.log('Received values of form: ', relation);

          let data = Crypter.encrypt(JSON.stringify(relation));

          let config = {
            method: 'put',
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            url: Data.ApiUrl.Updaterelation,
            headers: {
              // 'Accept': 'application/json',
              // 'CypherRelation': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };


          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data));

                if (res.StatutCode == 200) {
                  let code = relation.CODREL
                  form.resetFields()
                  localStorage.clear()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })

                  initialiazeButton()
                  localStorage.setItem(Data.LocalVariable.reset, '1')

                  setSbmit("")
                }
                else {
                  SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
            });
        }
      })
    }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {

    let data = form.getFieldValue("idClient")?form.getFieldValue("idClient"):'';
    let clearNumcli = form.getFieldValue("idClient");
    let LibNumcli = form.getFieldValue("lib_idClient");

    SetData([]);
    if (data.length >0) {
      initialiazeButton()
      setLoading(true)
      form.resetFields();

      form.setFieldValue("idClient", clearNumcli);
      form.setFieldValue("lib_idClient", LibNumcli);

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetRelation,
        headers: {
          'CypherNumcli': Crypter.encrypt(clearNumcli) ,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));

            if (res.StatutCode == 200) {
              if (res.Result.Table.length > 0) {
                SetData([]);
                setLoading(true);
                const datat: DataRelationClient[] = [];
                res.Result.Table.map((data: any, indice: number) => {
                  datat.push({
                    key: indice,
                    idclient: data.IdRel,
                    CODEREL: data.CODREL,
                    Nom: data.NomRel,
                    Prenom: data.Prenom,
                    Tel: data.TelRel,
                    filiation: data.filiation,
                    Datecre: data.DatCre,
                    RelObject: data
                  });
                })

                SetData(datat);
              } else { SweetAlert.fire({ title: "Warning", text: "le client ne possede pas aucune relation", icon: "warning" }) }

              cunsultButton();
              console.log(form.getFieldsValue());
            }
            else {
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Warning", text: error.message, icon: "warning" })
        });
    }
  }

  function modif() 
  {
    modifButton();
  }

  return (
    <div className='tab'>
      <Box className='formTitle'> <Breadcrumbs aria-label="breadcrumb">
        <StyledBreadcrumb
          component="a"
          href="/jjh"
          label="Home"
          icon={<HomeIcon fontSize="small" />}
        />
        <StyledBreadcrumb component="a" href="#" label="Gestion" />
        <StyledBreadcrumb
          label=" GESTION RELATION "
          deleteIcon={<ExpandMoreIcon />}

        />
      </Breadcrumbs></Box>
      <Spin spinning={loading} size='large' tip="En Cour de traitement..." style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Imprimer
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <Tabs size='large' type="card" defaultActiveKey="1" items={items} />

            <div>
            </div>
          </div>
        </Form>
        <div>
          <div>

          </div>
        </div>
      </Spin>
    </div>

  );
}
export default Relation;